(function () {
  const model = window.NJTWheelModel;
  if (!model || customElements.get('njt-wheel-filters')) return;
  const fieldLabel = (field, value) => field === 'size' || field === 'width' ? value + '"' : field === 'offset' ? (Number(value) > 0 ? '+' : '') + value + ' mm' : value;
  const element = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  class WheelFilters extends HTMLElement {
    queueBackground(callback) {
      this.backgroundCallback = callback;
      if (this.backgroundTimer) return;
      const flush = () => {
        this.backgroundTimer = null;
        if (!this.isConnected) { this.backgroundCallback = null; return; }
        if (matchMedia('(max-width: 989px)').matches && (this.backgroundTouch || Date.now() - (this.backgroundScroll || 0) < 220)) {
          this.backgroundTimer = setTimeout(flush, 120);
          return;
        }
        const run = this.backgroundCallback;
        this.backgroundCallback = null;
        run?.();
      };
      this.backgroundTimer = setTimeout(flush, 160);
    }
    initBackgroundQueue() {
      this.onBackgroundScroll = () => { this.backgroundScroll = Date.now(); };
      this.onBackgroundTouch = event => { this.backgroundTouch = event.touches.length > 0; this.backgroundScroll = Date.now(); };
      window.addEventListener('scroll', this.onBackgroundScroll, {passive:true});
      window.addEventListener('touchstart', this.onBackgroundTouch, {passive:true});
      window.addEventListener('touchend', this.onBackgroundTouch, {passive:true});
      window.addEventListener('touchcancel', this.onBackgroundTouch, {passive:true});
    }
    clearBackgroundQueue() {
      clearTimeout(this.backgroundTimer);
      this.backgroundTimer = null;
      this.backgroundCallback = null;
      window.removeEventListener('scroll', this.onBackgroundScroll);
      window.removeEventListener('touchstart', this.onBackgroundTouch);
      window.removeEventListener('touchend', this.onBackgroundTouch);
      window.removeEventListener('touchcancel', this.onBackgroundTouch);
    }
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.initBackgroundQueue();
      this.translations = JSON.parse(this.querySelector('.njt-wheels__translations').textContent);
      this.labels = this.dataset.labels.split('|');
      this.selected = this.readSelection();
      this.vehicle = new URL(location.href).searchParams.get('filter.p.m.organizer.car_models') || '';
      this.pageSize = Number(this.dataset.pageSize) || 24;
      this.returnState = window.NJTListReturn?.state();
      this.restoreVisible = Number(this.returnState?.visible) || 0;
      this.visible = Math.max(this.pageSize, this.restoreVisible);
      this.grid = this.querySelector('.njt-wheels__grid');
      this.status = this.querySelector('.njt-wheels__status');
      this.money = new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {style: 'currency', currency: this.dataset.currency || 'CAD'});
      this.querySelector('.njt-wheels__sidebar').open = !window.matchMedia('(max-width: 749px)').matches;
      this.setupMobileFilters();
      this.syncCategoryLinks();
      const vehicleLabel = this.querySelector('.njt-wheels__vehicle');
      if (vehicleLabel) {
        const option = [...document.querySelectorAll('#vehicle-identifiers option')].find(option => option.value === this.vehicle);
        vehicleLabel.textContent = this.vehicle ? (option ? option.textContent.trim() : this.vehicle) : this.translations.noVehicle;
      }
      this.querySelectorAll('.njt-wheels__group').forEach(group => group.addEventListener('toggle', () => { if (group.open) this.load(); }));
      this.querySelectorAll('.njt-wheels__clear-group').forEach(button => button.addEventListener('click', () => {
        const group = button.closest('.njt-wheels__group');
        this.selected[group.dataset.field] = [];
        this.update();
        group.querySelector('summary').focus({preventScroll: true});
      }));
      this.addEventListener('change', event => {
        const input = event.target;
        if (input.matches('.njt-wheels__option input')) {
          const values = this.selected[input.dataset.field];
          this.selected[input.dataset.field] = input.checked ? [...new Set([...values, input.value])] : values.filter(value => value !== input.value);
          this.update();
        }
        if (input.matches('.njt-wheels__sort select')) {
          const url = this.selectionURL();
          url.searchParams.set('sort_by', input.value);
          location.assign(url);
        }
      });
      this.querySelector('.njt-wheels__clear').addEventListener('click', () => {
        this.selected = Object.fromEntries(model.fields.map(field => [field, []]));
        this.update();
      });
      const moreButton=this.querySelector('.njt-wheels__more');
      const showMore=()=>{if(!this.results || this.visible>=this.results.length || this.returnSnapshot && !this.complete)return;this.visible+=this.pageSize;this.renderResults();};
      moreButton.addEventListener('click',showMore);
      if('IntersectionObserver' in window){this.moreObserver=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting))this.queueBackground(() => { this.update(false, true); showMore(); });},{rootMargin:'400px 0px'});this.moreObserver.observe(moreButton);}
      this.querySelector('.njt-wheels__retry').addEventListener('click', () => this.load());
      this.onPopState = () => {
        const url = new URL(location.href);
        if ((url.searchParams.get('filter.p.m.organizer.car_models') || '') !== this.vehicle || (url.searchParams.get('sort_by') || this.dataset.defaultSort) !== this.sort) {
          location.reload();
          return;
        }
        const next = this.readSelection();
        if (model.fields.every(field => JSON.stringify(next[field]) === JSON.stringify(this.selected[field]))) return;
        this.restoreVisible = 0;
        this.selected = next;
        this.update(false);
      };
      window.addEventListener('popstate', this.onPopState);
      this.sort = new URL(location.href).searchParams.get('sort_by') || this.dataset.defaultSort;
      this.renderInitialChoices();
      for (const field of this.returnState?.groups || []) {
        const group = [...this.querySelectorAll('.njt-wheels__group')].find(item => item.dataset.field === field);
        if (group) group.open = true;
      }
      this.syncClearButtons();
      this.returnSnapshot=window.NJTListReturn?.snapshot('.njt-wheels__grid');
      if(this.returnSnapshot){
        this.grid.innerHTML=this.returnSnapshot.html;
        this.grid.hidden=false;
        this.querySelector('.njt-wheels__count').textContent=this.returnSnapshot.count;
        this.renderChips();
        this.dataset.listReady='true';
        this.load();
      }
      else if (this.hasSelection()) {
        this.grid.hidden = true;
        this.querySelector('.njt-wheels__native-pagination').hidden = true;
        this.update(false);
      }
      else if (this.returnState) { this.load(); }
      else {
        this.preloadTimer = window.setTimeout(() => this.load(), 600);
      }
    }
    disconnectedCallback() {
      this.clearBackgroundQueue();
      window.removeEventListener('popstate', this.onPopState);
      window.clearTimeout(this.preloadTimer);
      this.moreObserver?.disconnect();
      this.mobileMedia?.removeEventListener?.('change', this.onMobileChange);
      if (this.dialog?.open) this.dialog.close();
      document.body.classList.remove('njt-wheel-modal-open');
    }
    setupMobileFilters() {
      this.dialog = this.querySelector('.njt-wheels__mobile-dialog');
      const panel = this.querySelector('.njt-wheels__panel');
      const trigger = this.querySelector('.njt-wheels__filter-trigger');
      if (!this.dialog || !panel || !trigger) return;
      const sidebar = this.querySelector('.njt-wheels__sidebar');
      this.mobileMedia = window.matchMedia('(max-width: 749px)');
      const sort = this.querySelector('.njt-wheels__sort');
      const sortHome = document.createComment('sort');
      sort.before(sortHome);
      const restore = () => {
        (this.mobileMedia.matches ? this.dialog.querySelector('.njt-wheels__dialog-body') : sidebar).append(panel);
        sortHome.after(sort);
        sidebar.open = !this.mobileMedia.matches;
      };
      this.onMobileChange = () => {
        if (this.dialog.open) this.dialog.close();
        restore();
      };
      this.mobileMedia.addEventListener?.('change', this.onMobileChange);
      this.onMobileChange();
      trigger.addEventListener('click', () => {
        const body = this.dialog.querySelector('.njt-wheels__dialog-body');
        body.append(sort, panel);
        this.dialog.showModal();
        document.body.classList.add('njt-wheel-modal-open');
        this.dialog.querySelector('.njt-wheels__close').focus();
        this.load();
      });
      this.dialog.addEventListener('close', () => {
        document.body.classList.remove('njt-wheel-modal-open');
        restore();
        trigger.focus({preventScroll: true});
      });
      for (const button of this.dialog.querySelectorAll('.njt-wheels__close, .njt-wheels__show-results')) button.addEventListener('click', () => this.dialog.close());
      this.dialog.querySelector('.njt-wheels__mobile-clear').addEventListener('click', () => this.querySelector('.njt-wheels__clear').click());
    }
    syncCategoryLinks() {
      const current = new URL(location.href);
      this.querySelectorAll('[data-wheel-category]').forEach(link => {
        const url = new URL(link.getAttribute('href'), location.origin);
        url.search = '';
        for (const key of ['filter.p.m.organizer.car_models', 'preview_theme_id', '_fd', 'pb']) {
          if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
        }
        link.href = url;
      });
    }
    renderInitialChoices() {
      if (this.dataset.brandMode === 'true') return;
      const choices = window.NJTWheelChoices;
      if (!choices) return;
      for (const field of model.fields) {
        const group = this.querySelector('[data-field="' + field + '"]');
        const fragment = document.createDocumentFragment();
        for (const value of [...new Set([...(choices[field] || []), ...this.selected[field]])]) {
          const label = element('label', 'njt-wheels__option');
          const input = document.createElement('input');
          input.type = 'checkbox'; input.value = value; input.dataset.field = field;
          input.checked = this.selected[field].includes(value);
          label.append(input, element('span', '', fieldLabel(field, value)));
          fragment.append(label);
        }
        group.querySelector('.njt-wheels__options').replaceChildren(fragment);
        group.querySelector('.njt-wheels__selection-count').textContent = this.selected[field].length ? '(' + this.selected[field].length + ')' : '';
      }
    }
    readSelection() {
      const params = new URL(location.href).searchParams;
      return Object.fromEntries(model.fields.map(field => [field, this.dataset.brandMode === 'true' && field === 'brand' ? [] : [...new Set(params.getAll('njt_' + field))]]));
    }
    hasSelection() { return model.fields.some(field => this.selected[field].length); }
    syncClearButtons() {
      this.querySelectorAll('.njt-wheels__clear-group').forEach(button => {
        button.hidden = this.selected[button.closest('.njt-wheels__group').dataset.field].length === 0;
      });
      this.querySelector('.njt-wheels__clear').hidden = !this.hasSelection();
      const count = model.fields.reduce((sum, field) => sum + this.selected[field].length, 0);
      const badge = this.querySelector('.njt-wheels__filter-count');
      if (badge) { badge.textContent = count; badge.hidden = !count; }
      const clear = this.querySelector('.njt-wheels__mobile-clear');
      if (clear) clear.disabled = !count;
    }
    selectionURL() {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      for (const field of model.fields) {
        url.searchParams.delete('njt_' + field);
        this.selected[field].forEach(value => url.searchParams.append('njt_' + field, value));
      }
      return url;
    }
    async load() {
      if (this.complete) return;
      if (this.loading) return this.loading;
      this.status.textContent = this.translations.loading;
      this.setAttribute('aria-busy', 'true');
      this.querySelector('.njt-wheels__retry').hidden = true;
      this.loading = (async () => {
        const base = new URL(this.dataset.collectionUrl, location.origin);
        const current = new URL(location.href);
        for (const [key, value] of current.searchParams) if (key.startsWith('filter.') || key === 'sort_by' || key === 'preview_theme_id') base.searchParams.append(key, value);
        base.searchParams.set('view', 'njt-wheel-data');
        const cacheKey = 'njt-wheel-index-v5:' + base.toString();
        try {
          const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
          if (cached && Date.now() - cached.at < (this.returnState ? 600000 : 180000) && Array.isArray(cached.products)) {
            const records = cached.products.map(product => ({...product, variants: product.variants.map(variant => [...variant.slice(0, 4), cached.vehicleSets[variant[4]] || [], ...variant.slice(5)])}));
            this.products = model.prepare(records);
            this.complete = true;
            this.status.textContent = '';
            this.update(false);
            return;
          }
        } catch (_) {}
        const read = async page => {
          const url = new URL(base);
          url.searchParams.set('page', page);
          const controller = new AbortController();
          const timeout = window.setTimeout(() => controller.abort(), 20000);
          try {
            // Shopify negotiates application/json as its collection metadata API,
            // ignoring the Liquid view. Request the view as HTML, then parse its JSON.
            const response = await fetch(url, {credentials: 'same-origin', signal: controller.signal, headers: {Accept: 'text/html'}});
            if (!response.ok) throw new Error('Wheel data request failed: ' + response.status);
            const data = await response.json();
            if (!Array.isArray(data.products) || Number(data.page) !== page || !Number.isInteger(data.pages)) throw new Error('Invalid wheel data');
            data.products = data.products.map(product => ({...product, variants: product.variants.map(variant => {
              if (Array.isArray(variant[4])) return variant;
              if (variant[4] == null) return [...variant.slice(0, 4), [], ...variant.slice(5)];
              if (!Number.isInteger(variant[4]) || !Array.isArray(product.vehicleSets?.[variant[4]])) throw new Error('Invalid wheel fitment data');
              return [...variant.slice(0, 4), product.vehicleSets[variant[4]], ...variant.slice(5)];
            })}));
            return data;
          } finally { window.clearTimeout(timeout); }
        };
        const first = await read(1);
        const pages = [first];
        const progress = () => this.queueBackground(() => {
          if (this.complete) { this.update(false, true); return; }
          const records = pages.filter(Boolean).flatMap(page => page.products);
          this.products = model.prepare(records);
          this.update(false, true);
          this.status.textContent = this.translations.loading + ' ' + Math.min(records.length, first.total) + ' / ' + first.total;
        });
        progress();
        let nextPage = 2;
        let stopped = false;
        await Promise.all(Array.from({length: Math.min(4, first.pages - 1)}, async () => {
          try {
            while (!stopped && nextPage <= first.pages) {
              const page = nextPage++;
              const response = await read(page);
              if (stopped) return;
              pages[page - 1] = response;
              progress();
            }
          } catch (error) { stopped = true; throw error; }
        }));
        const records = pages.filter(Boolean).flatMap(page => page.products);
        if (new Set(records.map(product => product.id)).size !== first.total || records.some(product => product.variantCount > product.variants.length)) throw new Error('Incomplete wheel data');
        this.products = model.prepare(records);
        this.complete = true;
        try {
          const vehicleSets = [], indices = new Map();
          const products = records.map(product => ({...product, variants: product.variants.map(variant => {
            const key = JSON.stringify(variant[4] || []);
            if (!indices.has(key)) { indices.set(key, vehicleSets.length); vehicleSets.push(variant[4] || []); }
            return [...variant.slice(0, 4), indices.get(key), ...variant.slice(5)];
          })}));
          sessionStorage.setItem(cacheKey, JSON.stringify({at: Date.now(), products, vehicleSets}));
        } catch (_) {}
        this.status.textContent = '';
        this.update(false);
      })().catch(error => {
        console.error('Wheel filters:', error);
        this.status.textContent = this.translations.error;
        this.querySelectorAll('.njt-wheels__muted').forEach(node => { node.textContent = this.translations.error; });
        this.querySelector('.njt-wheels__retry').hidden = false;
      }).finally(() => {
        this.loading = null;
        this.removeAttribute('aria-busy');
      });
      return this.loading;
    }
    update(writeHistory = true, backgroundReady = false) {
      if (!writeHistory && !backgroundReady) {
        this.queueBackground(() => this.update(false, true));
        return;
      }
      const focused = document.activeElement;
      const anchor = !writeHistory ? this.scrollAnchor() : null;
      const restoreFocus = focused && focused.matches('.njt-wheels__option input') ? {field: focused.dataset.field, value: focused.value} : null;
      if (writeHistory) history.pushState({}, '', this.selectionURL());
      this.syncClearButtons();
      this.renderChips();
      if (writeHistory) { this.restoreVisible = 0; this.returnState = null; this.returnSnapshot=null; this.visible=this.pageSize; }
      if(this.returnSnapshot && (!this.products || !this.complete))return;
      if(this.returnState && this.products && !this.complete)return;
      this.returnSnapshot=null;
      this.visible = Math.max(this.visible,this.pageSize,this.restoreVisible);
      if (!this.products) {
        this.renderInitialChoices();
        if (this.hasSelection()) {
          this.grid.hidden = true;
          this.querySelector('.njt-wheels__native-pagination').hidden = true;
        }
        this.load(); return;
      }
      this.results = model.filter(this.products, this.selected, this.vehicle);
      if (this.sort === 'price-ascending') this.results.sort((a, b) => a.price - b.price);
      if (this.sort === 'price-descending') this.results.sort((a, b) => b.price - a.price);
      if (this.sort === 'title-ascending') this.results.sort((a, b) => a.product.title.localeCompare(b.product.title));
      if (this.sort === 'title-descending') this.results.sort((a, b) => b.product.title.localeCompare(a.product.title));
      const facets = this.complete ? model.facets(this.products, this.selected, this.vehicle) : null;
      if (!this.complete) this.renderInitialChoices();
      for (const field of this.complete ? model.fields : []) {
        const group = this.querySelector('[data-field="' + field + '"]');
        const options = group.querySelector('.njt-wheels__options');
        const fragment = document.createDocumentFragment();
        for (const [value, count] of facets[field]) {
          const label = element('label', 'njt-wheels__option');
          const input = document.createElement('input');
          input.type = 'checkbox'; input.value = value; input.dataset.field = field;
          input.checked = this.selected[field].includes(value); input.disabled = count === 0 && !input.checked;
          label.append(input, element('span', '', fieldLabel(field, value)), element('small', '', '(' + count + ')'));
          fragment.append(label);
        }
        options.replaceChildren(fragment);
        group.querySelector('.njt-wheels__selection-count').textContent = this.selected[field].length ? '(' + this.selected[field].length + ')' : '';
      }
      this.renderResults();
      if (anchor) {
        const card = [...this.grid.children].find(item => item.querySelector('a[href]')?.pathname === anchor.product);
        if (card) {
          const delta = card.getBoundingClientRect().top - anchor.top;
          if (Math.abs(delta) > 1) window.scrollBy({top:delta,left:0,behavior:'instant'});
        }
      }
      if (restoreFocus) {
        const input = [...this.querySelectorAll('.njt-wheels__option input')].find(input => input.dataset.field === restoreFocus.field && input.value === restoreFocus.value);
        if (input) input.focus({preventScroll: true});
      }
    }
    scrollAnchor() {
      if (this.dialog?.open || !this.grid || this.grid.getBoundingClientRect().top > 0) return null;
      const edge = Math.max(0, this.querySelector('.njt-wheels__sticky-bar')?.getBoundingClientRect().bottom || 0);
      const card = [...this.grid.children].find(item => item.getBoundingClientRect().bottom > edge);
      const link = card?.querySelector('a[href]');
      return link ? {product:link.pathname,top:card.getBoundingClientRect().top} : null;
    }
    renderChips() {
      const chips = this.querySelector('.njt-wheels__chips');
      chips.replaceChildren();
      model.fields.forEach((field, index) => this.selected[field].forEach(value => {
        const chip = element('button', 'njt-wheels__chip', this.labels[index] + ': ' + fieldLabel(field, value) + ' ×');
        chip.type = 'button'; chip.setAttribute('aria-label', this.translations.remove + ' ' + this.labels[index] + ' ' + fieldLabel(field, value));
        chip.addEventListener('click', () => { this.selected[field] = this.selected[field].filter(item => item !== value); this.update(); });
        chips.append(chip);
      }));
      this.querySelector('.njt-wheels__clear').hidden = !this.hasSelection();
    }
    renderResults() {
      const fragment = document.createDocumentFragment();
      const shown=this.results.slice(0,this.visible);
      const signatures=shown.map(r=>JSON.stringify([r.product.id,r.variants.map(v=>v.id),r.price]));
      const old=this.renderedSignatures||[];
      const append=old.length>0 && old.length<=signatures.length && old.every((s,i)=>s===signatures[i]);
      for(const result of shown.slice(append?old.length:0))fragment.append(this.card(result));
      if(append)this.grid.append(fragment);else this.grid.replaceChildren(fragment);
      this.renderedSignatures=signatures;
      this.grid.hidden = false;
      this.dataset.listReady = this.complete ? 'true' : 'false';
      this.querySelector('.njt-wheels__native-pagination').hidden = true;
      this.querySelector('.njt-wheels__empty').hidden = !this.complete || this.results.length > 0;
      this.querySelector('.njt-wheels__more').hidden = this.visible >= this.results.length;
      this.querySelector('.njt-wheels__count').textContent = this.results.length + (this.complete ? '' : '+') + ' ' + this.translations.products;
      const count = this.results.length + (this.complete ? '' : '+');
      const headingCount = this.querySelector('.njt-wheels__heading-count');
      if (headingCount) headingCount.textContent = '(' + count + ')';
      const showResults = this.querySelector('.njt-wheels__show-results');
      if (showResults) showResults.textContent = this.translations.showCount.replace('__COUNT__', count);
      // Notify only after pagination, counts and buttons have their final sizes.
      if (this.complete) document.dispatchEvent(new CustomEvent('njt:list-ready'));
    }
    card({product, variants, price}) {
      const item = document.createElement('li');
      const card = element('article', 'njt-wheels__card njs-card');
      const cheapest = variants.find(variant => variant.price === price);
      const url = new URL(product.url, location.origin);
      for (const field of model.fields) this.selected[field].forEach(value => url.searchParams.append('njt_' + field, value));
      if (this.vehicle) url.searchParams.set('filter.p.m.organizer.car_models', this.vehicle);
      if (this.vehicle || ['size', 'width', 'offset'].some(field => this.selected[field].length)) url.searchParams.set('variant', cheapest.id);
      const imageLink = element('a', 'njt-wheels__image-link njs-card-image'); imageLink.href = url;
      const addImage = (source, className, alt) => {
        if (!source) return;
        const image = document.createElement('img'); image.src = source; image.alt = alt; image.width = 600; image.height = 600; image.loading = 'lazy'; image.decoding = 'async'; image.className = className;
        imageLink.append(image);
      };
      addImage(product.image, '', product.alt || product.title);
      if (this.dataset.showSecondary === 'true' && product.secondImage !== product.image) addImage(product.secondImage, 'njt-wheels__second-image', '');
      const heading = element('h3', 'njt-wheels__card-title');
      const titleLink = element('a', '', product.title); titleLink.href = url; heading.append(titleLink);

      const body = element('div', 'njs-card-body');
      card.append(imageLink, body);
      body.append(heading);
      if(this.vehicle && variants.some(v=>v.vehicles.includes(model.normalize(this.vehicle))))body.append(element('p','njt-card-fit',this.translations.fitsVehicle));
      if (['size', 'width', 'offset'].some(field => this.selected[field].length) && cheapest.spec) body.append(element('p', 'njt-wheels__specs', cheapest.spec.size + ' × ' + cheapest.spec.width + ' • ' + fieldLabel('offset', cheapest.spec.offset)));
      const priceNode = element('p', 'njs-price', new Set(variants.map(variant => variant.price)).size > 1 ? this.translations.from.replace('__PRICE__', this.money.format(price / 100)) : this.money.format(price / 100));
      const currentPrice = element('span', 'njs-current-price', priceNode.textContent);
      priceNode.textContent = ''; priceNode.append(currentPrice);
      if (cheapest.compare > price) {priceNode.classList.add('njs-price-sale');priceNode.append(element('s', '', this.money.format(cheapest.compare / 100)),element('span','njs-sale-inline',this.translations.sale));}
      if (!this.selected.size.length) {
        const sizes = [...new Set(variants.map(variant => variant.spec?.size).filter(Boolean))].sort((a, b) => Number(a) - Number(b));
        if (sizes.length) body.append(element('p', 'njt-wheels__sizes', this.translations.sizes + ': ' + sizes.map(size => size + '"').join(', ')));
      }
      body.append(priceNode);
      const inStock = cheapest.stock > 0 && cheapest.available;
      const stock = element('div', 'njs-stock' + (inStock ? '' : ' njs-stock-order'));
      stock.append(element('strong', '', inStock ? this.translations.inStock : this.translations.noStock));
      stock.append(element('span', inStock ? 'njs-stock-quantity' : 'njs-order-note', inStock ? this.translations.quantity.replace('__COUNT__', cheapest.stock >= 50 ? '50+' : cheapest.stock) : cheapest.available ? this.translations.orderNote : this.translations.outStock));
      body.append(stock);
      if (inStock && this.dataset.currency === 'CAD' && price > 35000) {const shipping=element('span','njs-shipping');shipping.innerHTML='<svg aria-hidden="true" viewBox="0 0 28 24" fill="currentColor"><path d="M2 3h15a1 1 0 0 1 1 1v3h4l5 6v6h-3a4 4 0 0 0-8 0H11a4 4 0 0 0-8 0H1V4a1 1 0 0 1 1-1zm17 6v5h6l-4-5z"/><circle cx="7" cy="19" r="3"/><circle cx="20" cy="19" r="3"/></svg>';shipping.append(document.createTextNode(this.translations.freeShipping));body.append(shipping);}
      const view = element('a', 'njs-view', this.translations.viewProduct);
      view.href = url;
      body.append(view);
      item.append(card);
      return item;
    }
  }
  customElements.define('njt-wheel-filters', WheelFilters);
})();
